import {useStorage} from '@vueuse/core'

export function useMainSidebarToggleState() {
  const isSidebarToggled = useStorage('is-sidebar-toggled', true)

  return {
    isSidebarToggled,
  }
}